var organizationSettingsNavigationConfig = [
    {
        id: 'organization-profile',
        title: 'Профайл организации',
        handle: 'organization-profile'
    },
];
export default organizationSettingsNavigationConfig;
